<template>
    <div>
        <a-form class="mt30 retrieve-form-item" ref="ruleForm" :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
            <slot name="header"></slot>
            <div v-for="(item, index) in formList" :key="index">
                <!-- 不可以是服务协议通知 二级隐藏 一级直接显示 或者 如果符合条件则显示 -->
                <template v-if="showFormItemFun(item)">
                    <!-- 手机号 -->
                    <template v-if="item.field_code == 'mobile'">
                        <!-- 防止表单自动填充问题 -->
                        <div style="position: fixed; right: -99999px; top: -99999px">
                            <input type="text" name="mobile" />
                            <input type="text" name="email" />
                            <input type="password" name="password" />
                        </div>
                        <!-- 防止表单自动填充问题 -->
                        <a-form-item :label="item.field_display">
                            <div slot="extra" class="fs12 g_error" v-if="item.hint">{{ item.hint }}</div>
                            <a-input
                                type="number"
                                @blur="handleRegPhoneEvent($event, 'mobile')"
                                :disabled="model.user_is_author == 1 && model.mobile != ''"
                                autocomplete="off"
                                :placeholder="`${$t('formConfig.please_enter' /* 请输入 */)}${item.field_display}`"
                                v-decorator="[
                                    item.field_code,
                                    {
                                        rules: [
                                            { required: true, message: item.hint_null },
                                            { pattern: new RegExp(/^1[\d]{10}$/), message: item.hint_null }
                                        ],
                                        trigger: 'blur'
                                    }
                                ]"
                            >
                                <!-- <a-button type="primary" class="code-btn" slot="addonAfter">
                                    <router-link :to="`/personal/pwd-phone/${$route.params.lang}/${$route.params.meeting_id}`">修改绑定手机</router-link>
                                </a-button> -->
                            </a-input>
                        </a-form-item>
                    </template>

                    <!-- 邮箱 -->
                    <template v-else-if="item.field_code == 'email'">
                        <a-form-item :label="item.field_display">
                            <div slot="extra" class="fs12 g_error" v-if="item.hint">{{ item.hint }}</div>
                            <a-input
                                type="text"
                                @blur="handleRegPhoneEvent($event, 'email')"
                                :disabled="model.user_is_author == 1 && model.email != ''"
                                autocomplete="off"
                                :placeholder="$t('formConfig.please_enter' /* 请输入 */) + $t('web.email' /* 邮箱 */)"
                                v-decorator="[
                                    item.field_code,
                                    {
                                        rules: [
                                            { required: true, message: item.hint_null },
                                            {
                                                pattern: /^[a-zA-Z0-9.!#$%&\'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
                                                message: item.hint_null
                                            }
                                        ],
                                        trigger: 'blur'
                                    }
                                ]"
                            >
                                <!-- <a-button type="primary" class="code-btn" slot="addonAfter">
                                    <router-link :to="`/personal/pwd-email/${$route.params.lang}/${$route.params.meeting_id}`">修改绑定邮箱</router-link>
                                </a-button> -->
                            </a-input>
                        </a-form-item>
                    </template>

                    <!-- 身份证 -->
                    <template v-else-if="item.field_code == 'cardno'">
                        <a-form-item :label="item.field_display">
                            <div slot="extra" class="fs12 g_error" v-if="item.hint">{{ item.hint }}</div>
                            <a-input
                                type="text"
                                autocomplete="off"
                                :placeholder="`${$t('formConfig.please_enter' /* 请输入 */)}${item.field_display}`"
                                v-decorator="[
                                    item.field_code,
                                    item.is_null == 1
                                        ? {
                                              rules: [
                                                  { required: true, message: $t('formConfig.please_enter_the_correct_id_card_number' /* 请输入正确的身份证号码 */) },
                                                  { validator: checkCardnoValidator }
                                              ],
                                              trigger: 'blur'
                                          }
                                        : {}
                                ]"
                            />
                        </a-form-item>
                    </template>

                    <!-- 国家 或 省市区 -->
                    <select-city v-else-if="item.field_type == 'region' || item.field_type == 'country'" :dataValue="citySelectData" :needCountry="item.field_type == 'country' ? 1 : 2"></select-city>

                    <!-- 其他字段 -->
                    <a-form-item v-else :label="item.field_display">
                        <div slot="extra" class="fs12 g_error" v-if="item.hint">{{ item.hint }}</div>

                        <!-- 多级下拉 -->
                        <a-tree-select
                            :tree-default-expand-all="true"
                            v-if="item.field_code == 'class_id'"
                            style="width: 100%"
                            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                            :tree-data="abstractClassList"
                            :placeholder="`${$t('web.please_select' /* 请选择 */)}${item.field_display}`"
                            v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]"
                        />

                        <!-- 日历date -->
                        <a-date-picker
                            v-else-if="item.field_type == 'date' || item.field_code == 'birthdate'"
                            v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]"
                        />

                        <!-- 普通文本框text -->
                        <a-input
                            v-else-if="item.field_type == 'text'"
                            :disabled="
                                (item.field_code == 'real_name' || item.field_code == 'family_name' || item.field_code == 'given_name') && model.user_is_author == 1 && model[item.field_code] != ''
                            "
                            type="text"
                            autocomplete="off"
                            :placeholder="`${$t('formConfig.please_enter' /* 请输入 */)}${item.field_display}`"
                            v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]"
                        />

                        <!-- 富文本编辑器 -->
                        <wang-editor
                            v-else-if="item.field_type == 'abstract' || item.field_code == 'resume'"
                            v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]"
                            :length-type="item.type"
                            :ref="item.field_code"
                        ></wang-editor>

                        <!-- 多行文本框textarea -->
                        <a-input
                            v-else-if="item.field_type == 'textarea'"
                            type="textarea"
                            autocomplete="off"
                            :placeholder="`请输入${item.field_display}`"
                            :auto-size="{ minRows: 3, maxRows: 3 }"
                            v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]"
                        />

                        <!-- 单选框radio -->
                        <a-radio-group v-else-if="item.field_type == 'radio'" v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]">
                            <template v-if="item.field_code == 'jcsq' || item.field_code == 'xcys'">
                                <a-radio v-for="(it, idx) in item.options" :key="'radio' + idx" :value="it.key == '是' ? '1' : '0'">{{ it.value }}</a-radio>
                            </template>
                            <!-- 学分 -->
                            <template v-else-if="item.field_code == 'score_type'">
                                <a-radio value="1">{{ $i18n.locale == 'cn' ? '是' : 'yes' }}</a-radio>
                                <a-radio value="0">{{ $i18n.locale == 'cn' ? '是' : 'no' }}</a-radio>
                            </template>
                            <template v-else>
                                <a-radio v-for="(it, idx) in item.options" :key="'radio' + idx" :value="it.key">{{ it.value }}</a-radio>
                            </template>
                        </a-radio-group>

                        <!-- 多选框checkbox -->
                        <a-checkbox-group v-else-if="item.field_type == 'checkbox'" v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]">
                            <a-checkbox v-for="(it, idx) in item.options" :key="'checkbox' + idx" :value="it.key">{{ it.value }}</a-checkbox>
                        </a-checkbox-group>

                        <!-- 分支机构 -->
                        <a-select
                            :mode="item.big_astrict > 1 ? 'multiple' : 'default'"
                            v-else-if="item.field_code == 'committee_branch'"
                            v-decorator="[
                                item.field_code,
                                {
                                    rules: [
                                        { required: item.is_null == 1, message: item.hint_null },
                                        {
                                            validator: (rule, value, callback) => {
                                                checkMaxSelectedNumber(item, rule, value, callback);
                                            }
                                        }
                                    ]
                                }
                            ]"
                        >
                            <a-select-option v-for="(it, idx) in branchList" :key="'select-multiple' + idx" :value="String(it.id)">{{ it.name }}</a-select-option>
                        </a-select>

                        <!-- 下拉选择框select -->
                        <a-select
                            :mode="item.big_astrict > 1 ? 'multiple' : 'default'"
                            v-else-if="item.field_type == 'select'"
                            v-decorator="[
                                item.field_code,
                                {
                                    rules: [
                                        { required: item.is_null == 1, message: item.hint_null },
                                        {
                                            validator: (rule, value, callback) => {
                                                checkMaxSelectedNumber(item, rule, value, callback);
                                            }
                                        }
                                    ]
                                }
                            ]"
                        >
                            <a-select-option v-for="(it, idx) in item.options" :key="'select' + idx" :value="it.key">{{ it.value }}</a-select-option>
                        </a-select>

                        <!-- 上传视频 -->
                        <!-- <a-upload v-else-if="item.field_code == 'abstract_annex'" name="Filedata" accept="video/*" :data="{...uploadVideoData,file_type:item.field_code}" :fileList="item.fileList||[]" list-type="picture" :action="uploadVideoUrl" :before-upload="(info) => beforeUpload(info,item)" @change="handleUploadVideoEvent($event,item)">
                            <input type="hidden" v-decorator="[item.field_code,{ rules: [{ required: item.is_null == 1, message: item.hint_null }] }]">
                            <a-button type="primary" icon="upload" :loading="item.loading" :disabled="item.loading" class="mr10 mb10">{{`${$t('personal.common.upload')}${item.field_display}`}}</a-button>
                        </a-upload> -->

                        <!-- 上传图片 -->
                        <a-upload
                            v-else-if="item.field_type == 'image'"
                            list-type="picture-card"
                            class="avatar-uploader"
                            :show-upload-list="false"
                            :action="uploadImageUrl"
                            :data="{ type: 1 }"
                            :before-upload="info => beforeUpload(info, item)"
                            :headers="uploadHeaders"
                            @change="handleChange($event, item)"
                        >
                            <input type="hidden" v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]" />
                            <a-spin v-if="form.getFieldValue(item.field_code)" :spinning="item.loading">
                                <img style="max-width: 100%" :src="form.getFieldValue(item.field_code) | urlFilter(250)" alt="file" />
                            </a-spin>
                            <div v-else>
                                <a-icon :type="item.loading ? 'loading' : 'plus'" />
                                <div class="ant-upload-text">{{ `${$t('web.upload' /* 上传 */)}${item.field_display}` }}</div>
                            </div>
                        </a-upload>

                        <!-- 上传文件file -->
                        <a-upload
                            v-else-if="item.field_type == 'file'"
                            :show-upload-list="false"
                            :action="uploadImageUrl"
                            :data="{ type: 1 }"
                            :before-upload="info => beforeUpload(info, item)"
                            :headers="uploadHeaders"
                            @change="handleChange($event, item)"
                        >
                            <input type="hidden" v-decorator="[item.field_code, { rules: [{ required: item.is_null == 1, message: item.hint_null }] }]" />
                            <a-button icon="upload" type="primary">{{ `${$t('web.upload' /* 上传 */)}${item.field_display}` }}</a-button>
                            <a class="ml10" v-if="form.getFieldValue(item.field_code)" @click="handleDownloadFileEvent(item.field_code)">{{ $t('web.click_download' /* 点击下载 */) }}</a>
                        </a-upload>
                    </a-form-item>
                </template>
            </div>
        </a-form>
    </div>
</template>

<script>
import wangEditor from '@/components/wangEditor/index.vue';
import * as judgeType from '@/utils/judgeDataType';
import userApi from '@/request/apiList';
import selectCity from '@/components/select-city.vue';
import moment from 'moment';
export default {
    name: 'ContributeForm',
    props: {
        // 表单列表
        list: {
            type: Array,
            default: () => []
        },
        model: {
            type: Object,
            default: () => null
        },
        channel_id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            // 文件请求头
            uploadHeaders: {},
            // 文件请求地址
            uploadImageUrl: userApi.uploadImage,
            form: this.$form.createForm(this),
            // 自定义表单列表
            formList: [],
            // 城市选择回显数据
            citySelectData: {},
            // 上传视频的参数
            uploadVideoData: {
                meeting_id: 0
            },
            // 上传视频的地址
            uploadVideoUrl: userApi.uploadVideo,
            // 验证码相关
            codetext: this.$t('web.get_verification_code' /* 获取验证码 */),
            disabled: false,

            // 表单响应式布局
            labelCol: (() => {
                let lang = this.$route.params.lang;
                return lang == 'en' ? { xs: { span: 24 }, sm: { span: 6 }, xl: { span: 4 } } : { xs: { span: 24 }, sm: { span: 24 }, xl: { span: 24 } };
            })(),
            wrapperCol: (() => {
                let lang = this.$route.params.lang;
                return lang == 'en' ? { xs: { span: 24 }, sm: { span: 18 }, xl: { span: 20 } } : { xs: { span: 24 }, sm: { span: 24 }, xl: { span: 24 } };
            })(),

            // 分会列表
            branchList: [],

            // 分类列表
            abstractClassList: []
        };
    },

    watch: {
        // 自定义表单
        list(newVal) {
            let formList = [];
            newVal.forEach(item => {
                if (judgeType.isString(item.options)) {
                    item.options = item.options.split('|');
                    item.options = item.options.map(it => ({ key: String(it), value: it }));
                }
                // 增加上传文件的loading参数
                if (item.field_type == 'image' || item.field_type == 'file') {
                    item.loading = false;
                }
                // 分会下拉选项单独处理
                if (item.field_code == 'committee_branch') {
                    this.getBranchList();
                }
                // 主题分类
                if (item.field_code == 'class_id') {
                    this.getAbstractClassList();
                }
                // 数据回显
                this.showDataFun(this.model, item);

                // 避免更新item时触发list的监听事件
                formList.push(JSON.parse(JSON.stringify(item)));
            });
            this.formList = formList;
        },

        // 监听model
        model: {
            handler(newVal) {
                if (newVal) {
                    // 城市数据回显
                    this.citySelectData = { country_id: newVal.country_id, province_id: newVal.province_id, city_id: newVal.city_id, area_id: newVal.area_id };
                    this.formList.forEach(item => {
                        // 数据回显
                        this.showDataFun(newVal, item);
                    });
                }
            },
            immediate: true,
            deep: true
        }
    },

    components: {
        selectCity,
        wangEditor
    },

    computed: {},
    created() {
        // 防止表单未注册
        // fields.forEach(v => this.form.getFieldDecorator(v))
    },
    methods: {
        // 下载文件
        handleDownloadFileEvent(field_code) {
            let a = document.createElement('a');
            a.href = 'https://files.sciconf.cn/' + this.form.getFieldValue(field_code);
            a.click();
        },
        // 校验
        formVerifyFun() {
            return new Promise((resovle, reject) => {
                this.form.validateFields((errors, values) => {
                    if (!errors) {
                        resovle(values);
                    } else {
                        this.$message.info(this.$t('web.please_fill_in_the_required_fields' /* 请填写必填项 */));
                    }
                });
            });
        },
        // 是否显示当前表单
        showFormItemFun(item) {
            let parent_code = item.parent_code && this.form.getFieldValue(item.parent_code);
            let is_show_child = false;
            if (Array.isArray(parent_code)) {
                parent_code.forEach(it => {
                    if (item.parent_value.includes(it)) {
                        is_show_child = true;
                    }
                });
            } else {
                if (item.parent_value) {
                    is_show_child = item.parent_value.includes(parent_code);
                }
            }
            return item.field_code != 'notice' && (item.parent_id == 0 || !item.parent_id || is_show_child);
        },

        // 递归格式化数据
        diffTreeFormatData(data, newList) {
            let { lang } = this.$route.params;
            data.forEach(item => {
                let newItem = {
                    key: item.class_id,
                    value: item.class_id,
                    title: item.name[lang],
                    disabled: false,
                    children: []
                };
                if (item.items?.length) {
                    newItem.disabled = true;
                    this.diffTreeFormatData(item.items, newItem.children);
                }
                newList.push(newItem);
            });
        },

        // 获取分会数据
        getBranchList() {
            this.$request.get({ url: 'getBranchList' }).then(res => {
                this.branchList = res.data;
            });
        },

        // 获取主题分类
        getAbstractClassList() {
            let channel_id = 0;
            if (this.$route?.query?.channel_id) {
                channel_id = Number(this.$route?.query?.channel_id) || 0;
            } else {
                channel_id = Number(this.channel_id) || 0;
            }
            this.$request.post({ url: 'getAbstractClass', data: { channel_id } }).then(res => {
                let abstractClassList = [];
                this.diffTreeFormatData(res.data, abstractClassList);
                this.abstractClassList = abstractClassList;
            });
        },

        // 数据回显方法
        showDataFun(data, item) {
            // 注册
            this.form.getFieldDecorator(item.field_code);
            // 赋值
            if (data) {
                let fieldForm = {};
                // 多选框回显
                if (item.field_type == 'checkbox' || (item.field_type == 'select' && item.big_astrict > 1)) {
                    data[item.field_code] && (fieldForm[item.field_code] = data[item.field_code].split('|'));
                    // 日期格式回显
                } else if (item.field_type == 'date' || (item.field_type == 'text' && item.field_code == 'birthdate')) {
                    data[item.field_code] && (fieldForm[item.field_code] = moment(data[item.field_code]));
                } else {
                    data[item.field_code] && (fieldForm[item.field_code] = data[item.field_code]);
                }
                this.form.setFieldsValue(fieldForm);
            }
        },

        // 上传视频
        handleUploadVideoEvent(info, currItem) {
            let fileList = [...info.fileList];
            fileList = fileList.slice(-1);
            fileList = fileList.map(file => {
                if (file.response) {
                    currItem.loading = true;
                    let { response } = file;
                    response = JSON.parse(response.substr(1, response.length - 2));
                    let { code, relative_path, absolute_path } = response;
                    if (code == 0) {
                        file.url = absolute_path;
                        this.form.setFieldsValue({
                            [currItem.field_code]: relative_path
                        });
                    }
                    currItem.loading = false;
                }
                return file;
            });

            if (!fileList.length) {
                this.form.setFieldsValue({
                    [currItem.field_code]: ''
                });
            }
            this.$set(currItem, 'fileList', fileList);
        },

        // 上传修改
        handleChange(info, currItem) {
            if (info.file.status === 'uploading') {
                currItem.loading = true;
                return;
            }
            if (info.file.status === 'done') {
                let { code, data, message } = info.file.response;
                if (code == 200) {
                    let obj = {};
                    obj[currItem.field_code] = data.relative_path;
                    this.form.setFieldsValue(obj);
                } else {
                    this.$message.error(message);
                }
                currItem.loading = false;
            }
        },

        // 上传前
        beforeUpload(file, currItem) {
            let regFile = true;
            // 头像的验证
            if (currItem.field_type == 'image') {
                let regFile = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
                if (!regFile) {
                    this.$message.error(this.$t('formConfig.only_upload_image' /* 只能上传图像文件 */));
                    return regFile;
                }
            }
            // 其他文件的验证
            if (currItem.field_type == 'file') {
                // 取后台上传的后缀配置
                let options = currItem.options || [];
                // 获取当前上传的文件后缀
                let suffix = file.name.split('.');
                suffix = suffix[suffix.length - 1];
                let optionList = [];
                options.forEach((item, index) => {
                    optionList.push(item.value);
                });
                if (optionList.length == 0 && optionList.indexOf(suffix) == -1) {
                    regFile = false;
                    this.$message.error(this.$t('formConfig.please_upload_the_suffix_of', { type: optionList.join('|') } /* 请上传后缀为 */));
                    return regFile;
                }
            }
            return regFile;
        },

        // 获取手机验证码
        handleSendSmsEvent() {
            let mobile = this.form.getFieldValue('mobile');
            if (mobile && /^1[\d]{10}$/.test(mobile)) {
                this.$request.post({ url: 'meetingSendSms', data: { mobile, sms_type: 2 } }).then(res => {
                    let wait = 60;
                    this.disabled = true;
                    let codeTextRef = this.$refs.codeText[0];
                    this.timer = setInterval(() => {
                        wait--;
                        codeTextRef.innerHTML = this.$t('common.retrieve.s_reset_text', { s: wait });
                        if (wait == 0) {
                            clearInterval(this.timer);
                            wait = 60;
                            this.disabled = false;
                            codeTextRef.innerHTML = this.$t('web.get_verification_code' /* 获取验证码 */);
                        }
                    }, 1000);
                });
            } else {
                this.$message.error(this.$t('common.retrieve.login_mobile'));
            }
        },

        // 确认密码
        confirmPasswordFun(rule, value, callback) {
            const form = this.form;
            if (value && value !== form.getFieldValue('password')) {
                callback(this.$t('common.retrieve.confirm_password_reg'));
            } else {
                callback();
            }
        },

        // 验证最大选择数量
        checkMaxSelectedNumber(item, rule, value, callback) {
            if (item.big_astrict > 1) {
                if (value.length > item.big_astrict) {
                    callback(this.$t('web.the_selected_number_cannot_exceed', { count: item.big_astrict } /* 选择的数量不能超过{count}条 */));
                    return false;
                }
                callback();
            }
            callback();
        },

        // 身份证验证
        checkCardnoValidator(rule, value, callback) {
            const provinceId = this.form.getFieldValue('province_id'); // 省份id
            if (!value) {
                // 因为已经有requred提示了，所以这里就不需要其他提示了
                callback('');
                return false;
            }
            // 港澳台不校验身份证
            if (provinceId != '3714' && provinceId != '3795' && provinceId != '3799') {
                if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
                    callback(this.$t('formConfig.the_id_card_number_format_is_incorrect' /* 身份证号格式不正确 */));
                    return false;
                }
            }
            //18位身份证需要验证最后一位校验位
            if (value.length == 18) {
                let code = value.split('');
                //∑(ai×Wi)(mod 11)
                //加权因子
                var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
                //校验位
                var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
                var sum = 0;
                var ai = 0;
                var wi = 0;
                for (var i = 0; i < 17; i++) {
                    ai = code[i];
                    wi = factor[i];
                    sum += ai * wi;
                }
                var last = parity[sum % 11];
                if (parity[sum % 11] != code[17]) {
                    callback(this.$t('formConfig.the_id_card_number_is_incorrect' /* 身份证号不正确 */));

                    return false;
                }
                callback();
            }
            callback();
        },

        // 手机号验证
        handleRegPhoneEvent(e, field) {
            let { value } = e.target;
            //是否为手机号码
            let lang = this.$route.params.lang;
            if (lang == 'en') {
                // 拒绝验证
                if (field == 'mobile') {
                    return false;
                }
                //是否为邮箱
                if (!/(^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$)/.test(value)) {
                    this.$message.error(this.$t('formConfig.please_enter_the_correct_email' /* 请输入正确的邮箱 */));
                    return false;
                }
            } else {
                // 拒绝验证
                if (field == 'email') {
                    return false;
                }
                // 是否为手机号
                if (!/(^1[\d]{10}$)/.test(value)) {
                    this.$message.error(this.$t('formConfig.please_enter_the_correct_phone_number' /* 请输入正确的手机号 */));
                    return false;
                }
            }

            this.$request.post({ url: 'getEmailMobile', data: { username: value }, costom: { hideModal: true } }).then(res => {
                // 如果已存在账户
                if (res.code == 200) {
                    this.$confirm({
                        title: '',
                        content: this.$t('formConfig.the_phone_number_already_exists' /* 该手机号码已经存在，请使用该手机号码直接登录或找回密码！ */),
                        okText: this.$t('web.immediately_login' /* 立即登录 */),
                        cancelText: this.$t('web.retrieve_password' /* 找回密码 */),
                        onOk: () => {
                            this.$router.replace({
                                path: `/login/${this.$route.params.committee_id}?m=${value}&redirect=${this.$route.redirect || ''}`
                            });
                        },
                        onCancel: () => {
                            this.$router.replace({
                                path: `/retrieve/${this.$route.params.committee_id}?m=${value}&redirect=${this.$route.redirect || ''}`
                            });
                        }
                    });
                }
            });
        }
    },

    mounted() {
        // this.uploadHeaders['meetingID'] = this.$route.params.meeting_id;
        // this.uploadHeaders['auth'] = this.$storage.get('token');
        this.uploadHeaders['meetingID'] = this.$route.params.meeting_id;
        this.uploadHeaders['mid'] = this.$route.params.meeting_id;
        this.uploadHeaders['auth'] = this.$storage.get('token');
        // 投稿表单中的上传视频中使用
        // let { abstract_id } = this.$route.query;
        // if (abstract_id) {
        //     this.uploadVideoData['code'] = abstract_id;
        // }
    }
};
</script>
<style lang="less" scoped>
.reg-title {
    border-bottom: 1px solid #ddd;
}
.avatar-uploader {
    /deep/.ant-spin-container {
        position: relative;
        overflow: hidden;
        &:before {
            opacity: 0;
            content: 'change';
            position: absolute;
            left: 0;
            top: 0;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.4);
        }
        &:hover {
            &:before {
                opacity: 1;
                z-index: 1;
            }
        }
    }
}
.retrieve-form-item {
    /deep/.ant-input {
        height: 36px;
    }

    /deep/.ant-input-group-addon {
        padding: 0;
    }
    .register-type {
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: @gap;
    }
    //.active {
    //    border-color: @theme;
    //   background: #fff url("~@/assets/images/select-icon.png") no-repeat right
    //        100%;
    //    background-size: 37.5px;
    //}
    .code-btn {
        height: 35px;
        border-radius: 0;
        display: block;
    }
}
@media screen and (max-width: 576px) {
    .retrieve-form-item {
        padding: 0;
    }
}
</style>
